module.exports = __webpack_public_path__ + "img/zm.f1b2beda.jpg";